import {
  ApplicationInsights,
  DistributedTracingModes,
} from '@microsoft/applicationinsights-web';
import { v4 as uuidv4 } from 'uuid';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import environment from '../environments/environment';

export const traceId = uuidv4();

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const appInsights =
  typeof environment.appInsights.connectionString === 'string' &&
  new ApplicationInsights({
    config: {
      connectionString: environment.appInsights.connectionString,
      distributedTracingMode: DistributedTracingModes.W3C,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
    },
  });

const appInsightsProxyHandler = {
  get(target: ApplicationInsights, prop: keyof ApplicationInsights) {
    const originalMethod = target[prop];
    if (!originalMethod || typeof originalMethod === 'function') {
      return (...args: unknown[]) => {
        if (
          appInsights &&
          originalMethod &&
          typeof originalMethod === 'function'
        ) {
          return originalMethod.apply(target, args);
        }
      };
    }
    return originalMethod;
  },
};

// proxy AppInsights to stub out method invocations when it isn't instantiated
const wrappedAppInsights: ApplicationInsights = new Proxy(
  Object.create(appInsights || {}),
  appInsightsProxyHandler,
);

wrappedAppInsights.loadAppInsights();
wrappedAppInsights.trackPageView();

export const telemetry = wrappedAppInsights;

export default wrappedAppInsights;
